"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateForDisplay = formatDateForDisplay;
exports.formatIncomingDate = formatIncomingDate;
exports.formatOutgoingDate = formatOutgoingDate;
exports.validateDate = validateDate;
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @param date
 * @param format
 * @returns {*}
 */
function formatDateForDisplay(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'll';
  return dates.getUTC(date, format);
}

/**
 * Date will be coming in as unix time / 1000
 * @param date
 * @returns {*}
 */
function formatIncomingDate(date) {
  return dates.getUTC(date, "YYYY/MM/DD");
}

/**
 * Convert the provided date to the start of that day (12AM) - This is only used for Birth dates, Hire Dates etc.. where time is not included. We set the in value to a truthy value (1) so as not to create any issues when a value of 0, (01/01/1970) is passed.
 * @param date
 * @returns {*}
 */
function formatOutgoingDate(date) {
  var ready = dates.getStartOfDay(date);
  if (ready === 0) {
    ready = 1;
  }
  return ready;
}

/**
 * @param date
 * @param noFuture
 * @param noPast
 * @param mustBeFirstOfMonth
 */
function validateDate(date) {
  var noFuture = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var noPast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var mustBeFirstOfMonth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var locale = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
  return dates.validate(date, noFuture, noPast, mustBeFirstOfMonth, locale);
}